const navScrollTabs = function () {
    const $sideScrollBtnPrev = $('.scrollNavFiltersPrev');
    const $sideScrollBtnNext = $('.scrollNavFiltersNext');
    const $sideScrollContainer = $('.navSideScroll');
    const sliderContainer = document.querySelector('.catalog-nav__sub-items');
    const sideScrollContainer = document.querySelector('.navSideScroll');
    let sliderScrollWidth;
    let  sliderWidth;
    if ($sideScrollContainer.length != 0){
        sliderScrollWidth = sideScrollContainer.scrollWidth;
        sliderWidth = sliderContainer.offsetWidth;
    }

    function conditionArrowFade () {
        if(sideScrollContainer.scrollLeft === 0) {
            $sideScrollBtnPrev.prop('disabled', true);
            $sideScrollContainer.removeClass("scroll-left");
        } else{
            $sideScrollBtnPrev.prop('disabled', false);
            $sideScrollContainer.addClass("scroll-left");
        }
        if(((sliderContainer.scrollWidth - 80) + sideScrollContainer.scrollLeft) > sideScrollContainer.scrollWidth){
            $sideScrollBtnNext.prop('disabled', true);
            $sideScrollContainer.removeClass("scroll-right");

        } else{
            $sideScrollBtnNext.prop('disabled', false);
            $sideScrollContainer.addClass("scroll-right");
        }
    }

    function scrollNavFilters () {
        const sideScrollDistance = 200;

        $sideScrollBtnNext.prop('disabled', false);

        function sideScroll(element,direction,speed,distance,step){
            scrollAmount = 0;
            var slideTimer = setInterval(function(){
                if(direction == 'left'){
                    element.scrollLeft -= step;
                } else {
                    element.scrollLeft += step;
                }
                scrollAmount += step;
                if(scrollAmount >= distance){
                    window.clearInterval(slideTimer);
                }
            }, speed);
        }

        function clickArrowToScroll(btnArrow, actionToScroll){

            btnArrow.on(actionToScroll, function() {

                if(btnArrow == $sideScrollBtnPrev){
                    sideScroll(sideScrollContainer,'left',25,sideScrollDistance,10);
                }

                if(btnArrow == $sideScrollBtnNext){
                    sideScroll(sideScrollContainer,'right',25,sideScrollDistance,10);
                }

                if(Revealizr.isDesktopSize){
                    conditionArrowFade();
                }

            })
        }

        clickArrowToScroll($sideScrollBtnNext, 'click');
        clickArrowToScroll($sideScrollBtnPrev, 'click');
        clickArrowToScroll($sideScrollContainer, 'mousemove');

    }

    function scrollToSelectedCategory () {
        const selectedCategory = document.querySelector('.selected_category');
        if (selectedCategory !== null) {
            let positionSelectedCategory = selectedCategory.offsetLeft;

            sideScrollContainer.scrollBy({
                left: positionSelectedCategory - 90,
                behavior: 'smooth'
            });
        }

        if(Revealizr.isDesktopSize){
            conditionArrowFade();
        }
    }

    if ($('.catalog-nav__sub-items').length && Revealizr.isDesktopSize) {
        let isDown = false;
        let startX;
        let scrollLeft;

        if (sliderScrollWidth > (sliderWidth - 80) && $sideScrollBtnNext.length) {
            scrollNavFilters();
        }

        sideScrollContainer.addEventListener('mousedown', (e) => {
            isDown = true;
            sideScrollContainer.classList.add('active');
            startX = e.pageX - sideScrollContainer.offsetLeft;
            scrollLeft = sideScrollContainer.scrollLeft;
        });
        sideScrollContainer.addEventListener('mouseleave', () => {
            isDown = false;
            sideScrollContainer.classList.remove('active');
        });
        sideScrollContainer.addEventListener('mouseup', () => {
            isDown = false;
            sideScrollContainer.classList.remove('active');
        });
        sideScrollContainer.addEventListener('mousemove', (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - sideScrollContainer.offsetLeft;
            const walk = (x - startX) * 2; //scroll-fast
            sideScrollContainer.scrollLeft = scrollLeft - walk;
        });
    }

    if (sliderScrollWidth > (sliderWidth - 80) && $sideScrollBtnNext.length) {
        scrollToSelectedCategory();
    }
}
$(function () {
    navScrollTabs();
});